module.exports = __webpack_public_path__ + "static/feature_tasks-b2005a62e7a9005484b906a872115b95.png";